import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { fetchQuiz } from "../services/quizzes";
import { fetchQuizWrapper } from "../services/quizWrappers";
import { fetchQuizResults } from "../services/quizResults";
import Loader from "components/shared/Loader";
import QuizWrapper from "components/quizBackgrounds/QuizWrapper";
import LocalMultiplayerOnboarding from "components/onboarding/LocalMultiplayerOnboarding";
import SoloOnboarding from "components/onboarding/SoloOnboarding";
import SafeScreen from "components/shared/SafeScreen";

const OnboardingPage = () => {
	const { quizId } = useParams();
	const navigate = useNavigate();

	const [quiz, setQuiz] = useState(null);
	const [quizWrapper, setQuizWrapper] = useState(null);
	const [player, setPlayer] = useState(null);
	const [selectedMode, setSelectedMode] = useState(null);
	const [initFinished, setInitFinished] = useState(false);
	const [room, setRoom] = useState({ current_player_index: 0, players: [] });

	useEffect(() => {
		const init = async () => {
			try {
				setInitFinished(false);

				let cachedQuiz = getCached("quiz");
				if (!cachedQuiz || cachedQuiz.id !== quizId) {
					const { data, error } = await fetchQuiz(quizId);
					if (error) throw new Error("Erreur lors du chargement du quiz.");
					cachedQuiz = data;
					localStorage.setItem("quiz", JSON.stringify(data));
				}
				setQuiz(cachedQuiz);

				const storedPlayer = getCached("player");
				let validPlayer = null;

				if (storedPlayer?.quizOrganizationId === cachedQuiz.organization_id) {
					let alreadyPlayed = false;
					const { data } = await fetchQuizResults({
						quizId,
						playerId: storedPlayer.id,
					});

					alreadyPlayed = !!data?.id;
					console.log("alreadyPlayed", alreadyPlayed);
					storedPlayer.alreadyPlayed = alreadyPlayed;
					localStorage.setItem("player", JSON.stringify(storedPlayer));
					validPlayer = storedPlayer;
				} else {
					localStorage.removeItem("player");
				}

				setPlayer(validPlayer);
				setInitFinished(true);
			} catch (error) {
				toast.error(error.message);
			}
		};

		init();
	}, [quizId]);

	// Helper
	const getCached = (key) => {
		try {
			const value = localStorage.getItem(key);
			return value ? JSON.parse(value) : null;
		} catch {
			return null;
		}
	};

	const getOnboardingComponent = () => {
		if (!quiz || !initFinished) return <Loader />;
		const { game_mode } = quiz;

		if (game_mode.length === 1 || selectedMode) {
			const mode = selectedMode || game_mode[0];
			const commonProps = { quiz, quizWrapper, navigate };

			return mode === "local_multiplayer" ? (
				<LocalMultiplayerOnboarding
					{...commonProps}
					room={room}
					setRoom={setRoom}
				/>
			) : mode === "solo" ? (
				<SoloOnboarding {...commonProps} initialPlayer={player} />
			) : (
				<div>Mode de jeu non supporté: {mode}</div>
			);
		}

		// Mode selector
		return (
			<div className="flex flex-col items-center w-full h-full mt-16 min-w-80 max-w-80 sm:min-w-96 sm:max-w-96 bg-white p-6 rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)] ">
				<h1 className="text-2xl text-gray-600 font-bold text-center mb-8">
					Choisissez un mode de jeu :
				</h1>
				<div className="flex flex-col gap-2 items-center">
					{game_mode.includes("local_multiplayer") && (
						<button
							onClick={() => setSelectedMode("local_multiplayer")}
							className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
						>
							Multijoueur local
						</button>
					)}
					{game_mode.includes("solo") && (
						<button
							onClick={() => setSelectedMode("solo")}
							className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
						>
							Solo
						</button>
					)}
				</div>
			</div>
		);
	};

	return (
		<SafeScreen className="flex flex-1">
			<QuizWrapper
				quizWrapper={quizWrapper}
				quizOrganizationId={quiz?.organization_id}
				room={room}
			/>
			<div className="flex items-center justify-center max-h-full w-full p-4">
				{getOnboardingComponent()}
			</div>
		</SafeScreen>
	);
};

export default OnboardingPage;
